import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CustomDropdownBtnComponent } from './custom-dropdown-btn.component';

const Components = [CustomDropdownBtnComponent];

@NgModule({
  imports: [CommonModule],
  exports: [Components],
  declarations: [Components],
  providers: []
})
export class CustomDropdownBtnModule {}
